import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ArrowRight } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-gray-950">
      <Header />
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="text-center space-y-6 py-20">
          <div className="text-6xl md:text-8xl font-bold text-white mb-4">
            404
          </div>
          <h1 className="text-2xl md:text-4xl font-bold text-white mb-2">
            Page Not Found
          </h1>
          <p className="text-lg text-gray-300 max-w-md mx-auto">
            The page you're looking for doesn't exist. Let's get you back on
            track.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-8">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-primary text-white px-8 py-3 rounded-lg font-semibold transition-all hover:shadow-lg hover:shadow-primary/30 hover:-translate-y-1"
            >
              Return to Home <ArrowRight size={20} />
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center justify-center gap-2 border-2 border-primary text-primary px-8 py-3 rounded-lg font-semibold transition-all hover:bg-blue-50"
            >
              Explore Services
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
